import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

export default function EmployeeDeleteModal(props) {
  const {
    showDeleteModal,
    handleDeleteModal,
    apiError,
    errorMessage,
    employeeId,
    removeEmployee,
    isDeleted,
  } = props || {};
  const [isDeleting, setIsDeleting] = useState(false);

  const removeEmployeeHandler = (employeeId) => {
    setIsDeleting(true);
    removeEmployee(employeeId);
  };

  useEffect(() => {
    if (isDeleted || apiError) {
      setIsDeleting(false);
    }
  }, [isDeleted, apiError]);

  const Spinner = () => (
    <div className="spinner-border spinner-border-sm text-light" role="status">
      <span className="sr-only"></span>
    </div>
  );

  return (
    <Modal show={showDeleteModal} onHide={handleDeleteModal}>
      <Modal.Body>
        Are you sure you want to delete this employee?
        {apiError && errorMessage && (
          <div className="error mt-2">{errorMessage}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          disabled={isDeleting}
          onClick={handleDeleteModal}
        >
          Close
        </Button>
        {!apiError && (
          <Button
            variant="danger"
            size="lg"
            onClick={() => removeEmployeeHandler(employeeId)}
          >
            {isDeleting ? Spinner() : "Delete"}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
